<template>
  <div class="section" v-loading="isLoading">
    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center" :span="22">
        <figure>
          <img
            class="premios"
            alt="Vue logo"
            :src="data.bubles[5].sectionImg"
            @load="loaded"
          />
        </figure>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'Section8',
  props: ['data'],
  setup (props) {
    const isLoading = ref(true)
    const loaded = () => {
      isLoading.value = !isLoading.value
    }
    return {
      isLoading,
      loaded
    }
  }
}
</script>
<style lang="scss" scoped>
.section{
  img{
    width: 100%;
  }
}
</style>
